/**
 * useMemeOfTheDay.js — TanStack Query hook for the Home page meme card.
 *
 * The server caches one meme per slot (morning motivation / afternoon cats,
 * flipping at noon America/Los_Angeles). staleTime is short enough that the
 * noon flip shows up on the next window focus without a hard reload.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useMemeOfTheDay() {
  return useQuery({
    queryKey: ['meme', 'today'],
    queryFn: () => api.get('/meme/today'),
    staleTime: 30 * 60 * 1000,
    retry: 1,
  });
}
